<template>
	<div class="page-start">
		<mdb-row class="justify-content-center">
			<mdb-col col="10">

			<!-- Alert Feedback -->
			<mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p1" @closeAlert="p1=false" dismiss>
				Success! Submitted War Report! Go to Submitted WARs Page? (Click "No" to start New War)
				"<router-link :to="{ name: 'Submitted-War' }"><mdbBtn class="QuadrusButton">Yes</mdbBtn></router-link>
				<mdbBtn color="danger" v-on:click="resetForm">No</mdbBtn>
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p2" @closeAlert="p2=false" dismiss>
				There was an error submitting WAR Report! Please try again!
			</mdb-alert>
			<mdb-alert id="feedback-success" class="mt-3" color="success" v-if="p3" @closeAlert="p3=false" dismiss>
				Success! Saved War Report! Go to Saved WARs Page? (Click "No" to start New War, or close to continue editing)
				<router-link :to="{ name: 'Edit-Saved-War' }"><mdbBtn class="QuadrusButton">Yes</mdbBtn></router-link>
				<mdbBtn color="danger" v-on:click="resetForm">No</mdbBtn>
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p4" @closeAlert="p4=false" dismiss>
				There was an error saving WAR Report! Please try again!
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p5" @closeAlert="p5=false" dismiss>
				There is already a report submitted for this Date Range and Project!
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p6" @closeAlert="p6=false" dismiss>
				There was an error retrieving data from the server! Please try again later.
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p7" @closeAlert="p7=false" dismiss>
				There is already a report saved for this Project and Task! Please submit it before starting a new one.
			</mdb-alert>
			<mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p8" @closeAlert="p8=false" dismiss>
				ERROR: Unable to Save or Submit WAR Report.
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="success" v-if="p9" @closeAlert="p9=false" dismiss>
				Success! Submitted WARs for "No Activity!"
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p10" @closeAlert="p10=false" dismiss>
				There was an error when trying to submit WARs for "No Activity." Please Try Again!
			</mdb-alert>
      <mdb-alert id="feedback-failure" class="mt-3" color="danger" v-if="p11" @closeAlert="p11=false" dismiss>
				There was an error when trying to populate charge lines for Quick Submit! Please Try Again!
			</mdb-alert>
			<!-- /Alert Feedback -->

			<mdb-card id="warCard" class="m-2"> 
				<mdb-card-body>
					<!-- Form Start -->
					<form @submit.prevent="checkForm" novalidate>
						<fieldset id="warForm"> 

						<h1 class="h1-responsive text-center mb-4">Work Activity Report</h1>
						<hr>
						<div class="grey-text" style="text-align: justify">

							<!-- First and Last Name -->
							<mdb-input basic class="mb-3" disabled :value="formWAR['firstLastName']">
								<span id="nameLabel" class="input-group-text" slot="prepend">First and Last name</span>
							</mdb-input>
							<!-- /First and Last Name -->

							<hr>
							<fieldset id="ProjTaskDate">

							<!-- Project Select -->
							<mdb-select id="projectSelect" label="Project" v-if="editing != true" @getValue="setProject" @change="validate('projectTask')"
								v-model="projectOptions" ref="validateProject"
							/>
							<div v-if="!editing && !formWAR['projectTask']" class="invalid-feedback d-block">
								Please select an project.
							</div>
							<div v-else-if="!editing" class="valid-feedback d-block">
								Looks Good!
							</div>
							<mdb-input v-if="editing == true" v-model="formWAR['projectTask']" basic class="mb-3" disabled></mdb-input>
							<!-- /Project Select -->

							<hr>

							<!-- Date Select -->
							<mdb-row>
								<mdb-col style="z-index: 1 !important; position: relative !important;">
									<mdb-date-picker-2 v-if="editing != true" label='Start Date' id="dateSelect1" title='Select Date'
									v-model="formWAR['startDate']" @change="handleChange('startDate')" 
									ref="startDate" @click="handleDatePickerClick('startDate')"/>	
									<div v-if="!editing && !formWAR['startDate']" class="invalid-feedback d-block">
										Please select a date.
									</div>
									<div v-else-if="!editing && formWAR['startDate'] && !validation['startDate'].valid" class="invalid-feedback d-block">
										Invalid Date.
									</div>
									<div v-else-if="!editing" class="valid-feedback d-block">
										Looks Good!
									</div>
								</mdb-col>

								<mdb-col>
									<mdb-date-picker-2 v-if="editing != true" label='End Date' id="dateSelect2" title='Select Date'
									v-model="formWAR['endDate']" @change="validate('endDate')" 
									ref="endDate" @click="handleDatePickerClick('endDate')"/>
									<div v-if="!editing && !formWAR['endDate']" class="invalid-feedback d-block">
										Please select a date.
									</div>
									<div v-else-if="!editing && formWAR['endDate'] && !validation['endDate'].valid" class="invalid-feedback d-block">
										Invalid Date.
									</div>
									<div v-else-if="!editing" class="valid-feedback d-block">
										Looks Good!
									</div>
								</mdb-col>
							</mdb-row>
							<!--<mdb-select id="dateSelect" label="Date Range" v-if="editing != true" @getValue="setDate" v-model="dateOptions"
								required validation ref="validateDate" invalidFeedback="Please select a date."
							/>-->
							<mdb-input v-if="editing == true" v-model="editingDate" basic class="mb-3" disabled></mdb-input>
							<!-- /Date Select -->
							
							</fieldset>
							<mdb-modal centered :show="viewModal" @close="refreshPageForEditing(), viewModal = false" style="z-index: 9999 !important; position: absolute !important;">
								<mdb-modal-header>
									<mdb-modal-title><p class="h2 grey-text">Details</p></mdb-modal-title>
								</mdb-modal-header>
								<mdb-modal-body style="font-size: 0.9em;">
									{{ existingWARDetails }}
								</mdb-modal-body>

								<mdb-modal-footer class="d-flex justify-content-center">
									<mdb-btn color="secondary" @click.native="refreshPageForEditing(), viewModal = false">Close</mdb-btn>
								</mdb-modal-footer>
							</mdb-modal>

							<hr>
							
							<!-- Activity Editor -->
							<span id="activityLabel" class="input-group-text" slot="prepend">Activity</span>						
							
							<textEditor ref="activityEditor" id="activityForm" v-if="editing != true" v-model="formWAR['activity']"
								@getContent='getActivity'/>
							<textEditor ref="activityEditor" id="activityEdit" v-if="editWAR" v-model="formWAR['activity']"
								:modelValue='this.editWAR.activity' @getContent='getActivity'
							/>
						
							
							<!-- /Activity Editor -->

							<!-- Activity Validation Icons -->
							<div id="activityValid" class="d-flex justify-content-end">
								<mdb-icon v-if="validation.activity.valid" id="activityValidMark" icon="check" size="lg" class="mr-4 green-text" 
									style="position: relative; bottom: 30px;" 
								/>
								<mdb-icon v-if="!validation.activity.valid" id="activityInvalidMark" icon="times" size="lg" class="mr-4 red-text" 
									style="position: relative; bottom: 30px;" 
								/>
							</div>
							<!-- /Activity Validation Icons -->

							<!-- Activity Validation Feedback -->
							<div v-if="!validation.activity.valid" id="activityValidation" class="invalid-feedback d-block">
								Please enter an activity using the bullet points.
							</div>
							<div v-if="validation.activity.valid" id="activityValidation" class="valid-feedback d-block">
								Looks Good!
							</div>
							<!-- /Activity Validation Feedback -->

							<hr>
						</div>

						<!-- Save & Submit Buttons if not Editing -->
						<div v-if="!editing" class="text-center">
							<mdb-btn id="submitWAR" class="QuadrusButton" v-on:click="setSubmitType('submit')" v-if="!submitProcessing" type="submit" 
								@click.native="$refs.validateProject.validate();"> <!--$refs.validateDate.validate();">-->
								Submit
							</mdb-btn>
							<mdb-btn v-if="submitProcessing">
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Processing...
							</mdb-btn>
						</div>
						<div v-if="!editing" class="text-center">
							<mdb-btn id="saveWAR" outline="primary" v-on:click="setSubmitType('save')" v-if="!submitProcessing" type="submit"
								@click.native="$refs.validateProject.validate();"> <!--$refs.validateDate.validate();">-->
								Save
							</mdb-btn>
							<mdb-btn v-if="submitProcessing">
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Processing...
							</mdb-btn>
						</div>
						<!-- /Save & Submit Buttons if not Editing -->

						<!-- Save & Submit Buttons if Editing -->
						<div v-if="editing" class="text-center">
							<mdb-btn id="submitWAR" class="QuadrusButton" v-on:click="setSubmitType('submit')" v-if="!submitProcessing" type="submit">
								Submit
							</mdb-btn>
							<mdb-btn v-if="submitProcessing">
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Processing...
							</mdb-btn>
						</div>
						<div v-if="editing" class="text-center">
							<mdb-btn id="saveWAR" outline="primary" v-on:click="setSubmitType('save')" v-if="!submitProcessing" type="submit">
								Save
							</mdb-btn>
							<mdb-btn v-if="submitProcessing">
								<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
								Processing...
							</mdb-btn>
						</div>
						<!-- /Save & Submit Buttons if Editing -->

						<!-- verify Modal -->
						<mdb-modal size="lg" centered :show="verifyModal" @close="verifyModal = false">
							<mdb-modal-header>
								<mdb-modal-title>Caution!</mdb-modal-title>
							</mdb-modal-header>
							<mdb-modal-body>
								<h5 class="h5">You are about to submit your WAR report!</h5>
								<p>Are you sure you want to continue?</p>
							</mdb-modal-body>
							<mdb-modal-footer class="d-flex justify-content-between">
								<mdb-btn color="secondary" @click.native="verifyModal = false">Cancel</mdb-btn>
								<mdb-btn class="QuadrusButton" v-on:click="submitted" @click.native="verifyModal = false">Submit</mdb-btn>
							</mdb-modal-footer>
						</mdb-modal>
						<!-- /Verify Modal -->

						</fieldset> 
					</form>
					<!-- /Form End -->

				</mdb-card-body>
			</mdb-card>
		</mdb-col>
	</mdb-row>
	</div>

</template>


<style>
	.ql-editor{
		color: black !important;
		min-height: 300px !important;
	}
</style>

<script>
import { mdbInput, mdbBtn, mdbCard, mdbCardBody, mdbCol,mdbRow, mdbAlert, mdbDatePicker2, mdbSelect, mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbIcon } from 'mdbvue';
import * as DatabaseLib from '@/assets/js/DatabaseLib.js';
import TextEditor from '@/components/TextEditor.vue';
import {identifyStringFormat} from '@/assets/js/JSONorHTML.js';
import {convertJSON} from '@/assets/js/JSONtoHTML.js';
import * as sanitizeInput from '@/assets/js/sanitizeInput.js';

export default {
	name: "NewWar",
	components: {
		mdbInput,
		mdbBtn,
		mdbCard,
		mdbCardBody,
		mdbCol,
		mdbRow,
		mdbAlert,
		mdbSelect,
		mdbModal, 
		mdbModalHeader, 
		mdbModalTitle, 
		mdbModalBody, 
		mdbModalFooter,
		mdbIcon,
		TextEditor,
		mdbDatePicker2
	},
	data() {
		return {
			editing: false,
			editingDate: '',

			verifyModal: false,
			viewModal: false,
			existingWARDetails: "",
			propData: [],
			submitProcessing: false,
			projectOptions: [],
			submitType: '',

			saveSuccess: false,
			monthOptions: [
                { text: 'January', value: '1', selected: false },
                { text: 'February', value: '2', selected: false },
                { text: 'March', value: '3', selected: false },
                { text: 'April', value: '4', selected: false },
                { text: 'May', value: '5', selected: false },
                { text: 'June', value: '6', selected: false },
                { text: 'July', value: '7', selected: false },
                { text: 'August', value: '8', selected: false },
                { text: 'September', value: '9', selected: false },
                { text: 'October', value: '10', selected: false },
                { text: 'November', value: '11', selected: false },
                { text: 'December', value: '12', selected: false }
            ],

      quickSubmitSelected: [],
      dateQuickSubmit: '',
      quickSubmitTable: {
        columns: [
        {
          label: 'Project',
          field: 'project',
          sort: 'true'
        }
        ],
        rows: []
      },

			formWAR: 
			{
				username: this.$store.getters.getUser,
				firstLastName: "",
				projectTask: '',
				startDate: '',
				endDate: '',
				activity: '<p></p>',
			},

			validation: {
				projectTask: {
					valid: false,
					validated: false
				},
				startDate: {
					valid: false,
					validated: false
				},
				endDate: {
					valid: false,
					validated: false
				},
				activity: {
					valid: false,
					validated: false
				}
			},

			p1: false,
			p2: false,
			p3: false,
			p4: false,
			p5: false,
			p6: false,
			p7: false,
			p8: false,
      p9: false,
      p10: false,
      p11: false
		}
	},

	props: 
	{
		editWAR: 
		{
			id: String,
			projectTask: String,
			activity: Object,
			startDate: String,
			endDate: String,
			editing: Boolean,
			default: null
		}
	},

	/* ----------------- Methods Start ----------------- */
	methods: 
	{

    test: function() {
      console.log("triggered");
    },


		//===========================================================================================
		//	Method Name	:	bindProps
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	----------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	If editWAR parameter is set, sets form to editing mode and populates fields using props
		//	given by parent.
		//===========================================================================================
		bindProps: async function() 
		{
			if(this.editWAR != null) 
			{
				this.editing = true;
				this.formWAR['projectTask'] = this.editWAR.projectTask;
				this.formWAR['activity'] = await this.editWAR.activity;
	
				// This is to help with user readability for the date range
				this.formWAR['startDate'] = this.editWAR.startDate;
				this.formWAR['endDate'] = this.editWAR.endDate;
				
				let start = new Date(this.editWAR.startDate);
				let end = new Date(this.editWAR.endDate);
				
				this.editingDate = (start.getUTCMonth() + 1) + "/" + start.getUTCDate() + " - " + (end.getUTCMonth() + 1) + "/" + end.getUTCDate();
				this.validate('activity');
			}
		},

		//===========================================================================================
		//	Method Name	:	verifyModal
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	----------	-------------------------------------
		//  Return Value			boolean			OUT			Date is valid or not.
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Verifies that the user wnats to submit their WAR. Prevents accidental submissions.
		//===========================================================================================
		verifyModalCall: function() 
		{
			this.verifyModal = true;
		},

		handleChange: function(key) {
			let isValid = this.validate(key);
			if(isValid) this.checkDate();
		},


		//===========================================================================================
		//	Method Name	:	checkForm
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//	event					event			IN			Form submission event.
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Validates form inputs and provides validation classes and CSS feedback to each input.
		//	If any form inputs are invalid for submission, method returns null. If a war report with
		//	the same date range, project and task is found in the database, an alert is shown to the
		//	user and the method returns null. Otherwise, the submitType is checked and calls the 
		//	appropriate method [saved() or submitted()].
		//===========================================================================================
		checkForm: async function() 
		{		
			let isValid = true;
			await Object.keys(this.formWAR).forEach(async key => {

				if(key == 'projectTask' || key == 'startDate' || key == 'endDate' || key == 'activity'){					
					if(!await this.validate(key)) {
						isValid = false;

						window.scroll({top: 0, behavior: 'smooth'});
						this.p12 = true;
						return;
					}
				}
			})

			// Check submit type to determine which function to execute
			if (isValid && this.submitType === 'submit')
			{
				let submitForm = false;
				submitForm = this.verifyModalCall();

				// If verifyModal returns true, call submitted method
				if (submitForm == true)
				{
					this.submitted();
				}
			}
			else if (isValid && this.submitType === 'save')
			{
				this.saved();
			}
			else
			{
				window.scroll({top: 0, behavior: 'smooth'});
				this.p8 = true;
			}
		},

		validate: function(key){		
			if(key == 'projectTask'){
				if(!this.formWAR[key]){
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else {
					this.validation[key].valid = true;
				}
				this.validation[key].validated = true;
			}
			if(key == 'startDate' || key == 'endDate'){
				const match = /^(\d{2,4})[/-](\d{2})[/-](\d{2,4})$/.exec(this.formWAR[key]);
				if(this.formWAR[key] == ''){
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else if (!match) {
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else {
					let year;
					let month;
					let day;
					// Determine whether the format is YYYY/MM/DD or MM/DD/YYYY
					if (match[1].length === 4) {
						year = Number(match[1]);
						month = Number(match[2]);
						day = Number(match[3]);
					} else if (match[3].length === 4) {
						month = Number(match[1]);
						day = Number(match[2]);
						year = Number(match[3]);
					} else {
						// Neither the first nor last part is a 4-digit year
						this.validation[key].valid = false;
						this.validation[key].validated = true;
						return false;
					}
					const date = new Date(year, month - 1, day);
					// Make sure JavaScript didn't roll the date over
					const isValidDate =
						date.getFullYear() === year &&
						date.getMonth() === month - 1 &&
						date.getDate() === day;

					// Today's date without time
					const today = new Date();
					today.setHours(0, 0, 0, 0);
					if (!isValidDate) {
						this.validation[key].valid = false;
						this.validation[key].validated = true;
						return false;
					} else {
						this.validation[key].valid = true;
					}
				}
				// end date must be after start date
				if((this.formWAR['startDate'] && this.formWAR['endDate']) && (this.formWAR['startDate'] >= this.formWAR['endDate'])){
					this.validation['endDate'].valid = false;
					this.validation[key].validated = true;
					return false;
				}
				this.validation[key].validated = true;
			}
			if(key == 'activity'){
				let content = this.formWAR.activity;
				if(identifyStringFormat(this.formWAR.activity) == "JSON"){
					content = JSON.parse(content).content[0].content[0].content[0].content[0];
				} else {
					let regex = /(<([^>]+)>)/ig;
					content = content.replace(regex, "");
				}
				if(!content){
					this.validation[key].valid = false;
					this.validation[key].validated = true;
					return false;
				} else {
					this.validation[key].valid = true;
				}
				this.validation[key].validated = true;
			}
			return true;
		},
		

		//===========================================================================================
		//	Method Name	:	disableForm
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	----------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Checks submit type and disabled sections accordingly. If form is submitted, disables
		//	the entire form. If form is saved, disables project, task, and date fields.
		//===========================================================================================
		disableForm: function() 
		{
			if (this.submitType === "submit") 
			{
				document.getElementById("warForm").disabled = "disabled";
				document.getElementById("warCard").classList.add("disabledForm");
				document.getElementById("nameLabel").classList.add("disabledForm");
				document.getElementById("activityLabel").classList.add("disabledForm");
			}
			else if (this.editing != true && this.submitType === "save") 
			{
				//disable Project, Task, and Date select if saved report
				document.getElementById("ProjTaskDate").disabled = "disabled";
			}
		},

		//===========================================================================================
		//	Method Name	:	getActivity
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//	jsonContent				Object			IN			Json Object of the activity field.
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Converts the Json Content in the activity field to a string and stores it in the
		//	activity field of formWAR.
		//===========================================================================================
		getActivity: function(jsonContent) 
		{
			this.formWAR.activity = jsonContent;
			this.validate('activity');
		},
		

		//===========================================================================================
		//	Method Name	:	populateFields
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	----------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Populates first and last name field, project selection dropdown, and date range dropdown.
		//	Projects options are based on what contracts user is assigned too.
		//===========================================================================================
		populateFields: async function() 
		{

			let token = this.$store.getters.getToken;
			let addProject = true;
				
			this.formWAR['firstLastName'] = await this.getLoggedInUser();

			try 
			{
				let query = 'filters[username][$eq][0]='+this.$store.getters.getUser+'&filters[disabled][$eq][1]='+false;
				let chargeLines = await DatabaseLib.getRequest('strapiDatabase','assigned-contracts',token,query);
				for(let i = 0; i < chargeLines.data.data.length; i = i + 1) 
				{
					addProject = true;
					// Check if project is already in options
					for (let j = 0; j < this.projectOptions.length; j = j + 1)
					
					{
						if (this.projectOptions[j].text === chargeLines.data.data[i].attributes.project)
						{
							addProject = false;
							break;
						}
					}

					// Add project if not already in options
					if (addProject == true)
					{
						this.projectOptions.push( {text: chargeLines.data.data[i].attributes.project, value: chargeLines.data.data[i].attributes.project} );
					}
				}

			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}

			//this.populateWeeks();

		},

		//===========================================================================================
		//	Method Name	:	resetForm
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Refreshes page to reset fields and CSS.
		//===========================================================================================
		resetForm: function() 
		{
			this.$router.go(0);
		},

		cleanHtmlString(html) {
			const parser = new DOMParser()
			const doc = parser.parseFromString(html, 'text/html')

			// Remove empty <p> and <li>
			doc.querySelectorAll('p, li').forEach(node => {
				if (!node.textContent.trim()) {
					node.remove()
				}
			})

			// Remove empty <ul> or <ol>
			doc.querySelectorAll('ul, ol').forEach(node => {
				if (!node.querySelector('li')) {
					node.remove()
				}
			})

			// Return cleaned HTML
			return doc.body.innerHTML
		},

		getLoggedInUser: async function () {
			let token = this.$store.getters.getToken;
			try 
			{
				let response = await DatabaseLib.getRequest('strapiDatabase','users/me',token);
				let tempFName = response.data.firstName;
				let tempLName = response.data.lastName;

				return tempFName + " " + tempLName;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p6 = true;
				return;
			}
		},


		//===========================================================================================
		//	Method Name	:	saved
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Calls sanitizeInput method to sanatize form inputs and attempts to enter war into the
		//	database as "Saved". If successful, disables editing of Project, Task, and Date Range
		//	for current WAR and enables alert providing the option to continue editing this WAR,
		//	starting a new WAR, or viewing the saved WAR table. If database submission fails, the
		//	error alert is enabled.
		//===========================================================================================
		saved: async function () 
		{
			this.submitProcessing = true;
			// Sanatizes formWAR inputs
			this.formWAR['projectTask'] = sanitizeInput(this.formWAR['projectTask'], this.$sanitize);
			this.formWAR['startDate'] = sanitizeInput(this.formWAR['startDate'], this.$sanitize);
			this.formWAR['endDate'] = sanitizeInput(this.formWAR['endDate'], this.$sanitize);
			
			this.formWAR['activity'] = await this.$refs.activityEditor.sanitizeActivity();
			this.formWAR['activity'] = await this.cleanHtmlString(this.formWAR['activity']);
			this.$refs.activityEditor.updateEditor(this.formWAR['activity']);

						
			let token = this.$store.getters.getToken
			let response = "";
			// Attempt submitting WAR to the database
			try 
			{
				let query = "filters[username][$eq][0]=" + this.formWAR['username'] + "&filters[projectTask][$eq][1]=" +
				encodeURIComponent(this.formWAR['projectTask']);

				query = query + "&filters[submitted][$eq][3]="+false;
				// Response checks if saved WAR already exists or not
				response =  await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
				let queryDivision = "filters[project][$eq][0]="+encodeURIComponent(this.formWAR['projectTask']);
				let getDivision = await DatabaseLib.getRequest('strapiDatabase','assigned-contracts',token,queryDivision);
				let sDate = new Date(this.formWAR['startDate']);
				let eDate = new Date(this.formWAR['endDate']);
				let div = "";
				if(getDivision.data.data.length > 0){
					div = getDivision.data.data[0].division;
				}
				let data = {
					data:
					{
						firstLastName: await this.getLoggedInUser(),
						projectTask: this.formWAR['projectTask'],
						activity: this.formWAR['activity'],//JSON.parse(this.formWAR['activity']),
						username: this.formWAR['username'],
						startDate: new Date(sDate.getTime() - sDate.getTimezoneOffset() * -60000 ),
						endDate: new Date(eDate.getTime() - eDate.getTimezoneOffset() * -60000 ),
						submitted: false,
						division: div,
						lastSaved: new Date().toISOString()
					}	
				}
				
				if(response.data.data.length == 0) // If saved WAR does not exist, create it
				{	
					await DatabaseLib.postRequest('strapiDatabase','war-reports',token,data);
				}
				else if(response.data.data.length > 0) // If saved WAR already exists, update it
				{
					await DatabaseLib.putRequest('strapiDatabase','war-reports',token,response.data.data[0].id,data);
				}			
				
				this.disableForm();
				window.scroll({top: 0, behavior: 'smooth'});
				this.p3 = true;	
				this.saveSuccess = true;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p4 = true;
				this.submitProcessing = false;
				return;
			}

			this.submitProcessing = false;
		},


		//===========================================================================================
		//	Method Name	:	setProject
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//	value					string			IN			Project string to set as projectTask.
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Sets formWAR projectTask field as given project string value.
		//===========================================================================================
		setProject: function(value) 
		{
			this.formWAR['projectTask'] = value;
			this.checkDate(this.formWAR['startDate']);
		},

		//===========================================================================================
		//	Method Name	:	setSubmitType
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//	value					string			IN			Submit Type string.
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Sets the submit type to the given value.
		//===========================================================================================
		setSubmitType: function(value) 
		{
			this.submitType = value;
		},


		checkDate: async function(sdate){
			let token = this.$store.getters.getToken;
			let response = "";
			let query = "";
			if(this.formWAR['projectTask']){
				try{
					if(sdate){
						query = "filters[username][$eq][0]=" + this.formWAR['username']+"&filters[projectTask][$eq][1]=" +
						encodeURIComponent(this.formWAR['projectTask']) + "&filters[startDate]][$eq][2]=" + sdate 
						+ "&filters[submitted]][$eq][3]=" + true;
						response =  await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);
						
						
						if(response.data.data.length > 0){		
							this.viewModal = true;
							this.existingWARDetails = "A WAR report has already been submitted for " + this.formWAR['projectTask'] + " with a start date of " + this.formWAR['startDate'];
							this.formWAR['startDate'] = "";					
						}
					}

					query = "filters[username][$eq][0]=" + this.formWAR['username']+"&filters[projectTask][$eq][1]=" +
					encodeURIComponent(this.formWAR['projectTask'])	+ "&filters[submitted]][$eq][2]=" + false;
					response =  await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);

					if(response.data.data.length > 0){
						this.viewModal = true;
						this.existingWARDetails = "A WAR report has already been saved for " + this.formWAR['projectTask'] + " with a start date of " + response.data.data[0].attributes.startDate +
							". Click close to edit.";		
						
						if(identifyStringFormat(response.data.data[0].attributes.activity) == "JSON"){
							response.data.data[0].attributes.activity = convertJSON(response.data.data[0].attributes.activity);
						}
						this.propData = {
							id: response.data.data[0].id,
							projectTask: response.data.data[0].attributes.projectTask,
							activity: response.data.data[0].attributes.activity,
							startDate: response.data.data[0].attributes.startDate,
							endDate: response.data.data[0].attributes.endDate,
							editing: true
						}
					}
				} catch(error) {
					console.log(error);
					window.scroll({top: 0, behavior: 'smooth'});
					//this.p2 = true;
					this.submitProcessing = false;
					return;					
				}
			}
		},

		refreshPageForEditing: function(){
			if(this.propData.id){
				this.$router.replace("/").then(() => this.$router.push({
					name: 'New-War',
					params: {
						editWAR: this.propData
					}
				}))
			}
		},
		

		//===========================================================================================
		//	Method Name	:	submitted
		//	
		//  Parameters
		//  Name					Type			Direction	Description
		//  ----------------------	--------------	---------	-------------------------------------
		//  Return Value			void			n/a			n/a
		//
		//	Description
		//	-----------------------------------------------------------------------------------------
		//	Calls sanitizeInput method to sanatize form inputs and attempts to enter war into the
		//	database as "Submitted". If successful, disables editing of entire form for current
		//	WAR and enables alert providing the option to view submitted WAR table or create new WAR.
		//	If database submission fails, the error alert is enabled.
		//===========================================================================================
		submitted: async function () 
		{
			this.submitProcessing = true;
			// Sanatizes formWAR inputs

			this.formWAR['projectTask'] = sanitizeInput(this.formWAR['projectTask'], this.$sanitize);
			this.formWAR['startDate'] = sanitizeInput(this.formWAR['startDate'], this.$sanitize);
			this.formWAR['endDate'] = sanitizeInput(this.formWAR['endDate'], this.$sanitize);

			this.formWAR['activity'] = await this.$refs.activityEditor.sanitizeActivity();
			this.formWAR['activity'] = await this.cleanHtmlString(this.formWAR['activity']);
			this.$refs.activityEditor.updateEditor(this.formWAR['activity']);

			let token = this.$store.getters.getToken;

			// Attempt submitting WAR to the database
			try 
			{
				let query = "filters[username][$eq][0]=" + this.formWAR['username']+"&filters[projectTask][$eq][1]=" +
				encodeURIComponent(this.formWAR['projectTask']);
				
				query = query + "&filters[submitted][$eq][3]="+false;

				// Response checks if saved WAR already exists or not
				let response =  await DatabaseLib.getRequest('strapiDatabase','war-reports',token,query);

				let queryDivision = "filters[project][$eq][0]="+encodeURIComponent(this.formWAR['projectTask']);
				let getDivision = await DatabaseLib.getRequest('strapiDatabase','assigned-contracts',token,queryDivision);

				let sDate = new Date(this.formWAR['startDate']);
				let eDate = new Date(this.formWAR['endDate']);

				let div = "";
				if(getDivision.data.data.length > 0){
					div = getDivision.data.data[0].division;
				}

				let data = 
				{
					data: {
						firstLastName: await this.getLoggedInUser(),
						projectTask: this.formWAR['projectTask'],
						activity: this.formWAR['activity'], //JSON.parse(this.formWAR['activity']),
						username: this.formWAR['username'],
						startDate: new Date(sDate.getTime() - sDate.getTimezoneOffset() * -60000 ),
						endDate: new Date(eDate.getTime() - eDate.getTimezoneOffset() * -60000 ),
						submitted: true,
						division: div
					}
				}
				

				if(response.data.data.length == 0)	// If saved WAR does not exist, create it
				{
					await DatabaseLib.postRequest('strapiDatabase','war-reports',token,data);
				} 
				else if(response.data.data.length > 0) // If saved WAR exists, update it
				{
					await DatabaseLib.putRequest('strapiDatabase','war-reports',token,response.data.data[0].id,data);
				}

				window.scroll({top: 0, behavior: 'smooth'});
				
				this.disableForm();
				this.p1 = true;
			} 
			catch (error)
			{
				console.log(error);
				window.scroll({top: 0, behavior: 'smooth'});
				this.p2 = true;
				this.submitProcessing = false;
				return;
			}
			this.submitProcessing = false;
		},


		handleDatePickerClick: function(key) {
			if (this.validation[key].validated && !this.validation[key].valid) {
				this.formWAR[key] = null;
				this.validation[key].valid = true;
				this.validation[key].validated = false;
			}
		},
	},
	
	/* ------------------ Methods End ------------------ */
	beforeDestroy() {
		const picker = this.$refs.startDate;
		if (picker && picker.$el && this.startDatePickerHandler) {
			const button = picker.$el.querySelector('i');

			if (button) {
				button.removeEventListener(
					'click',
					this.startDatePickerHandler,
					true
				);
			}
		}

		const picker2 = this.$refs.endDate;
		if (picker2 && picker2.$el && this.endDatePickerHandler) {
			const button2 = picker2.$el.querySelector('i');

			if (button2) {
				button2.removeEventListener(
					'click',
					this.endDatePickerHandler,
					true
				);
			}
		}
	},
	mounted() {
		this.populateFields();
		this.bindProps();

		this.$nextTick(() => {
			const picker = this.$refs.startDate;

			if (picker && picker.$el) {
				const button = picker.$el.querySelector('i');

				if (button) {
					this.startDatePickerHandler = () =>
						this.handleDatePickerClick('startDate');

					button.addEventListener(
						'click',
						this.startDatePickerHandler,
						true
					);
				}
			}

			const picker2 = this.$refs.endDate;

			if (picker2 && picker2.$el) {
				const button2 = picker2.$el.querySelector('i');

				if (button2) {
					this.endDatePickerHandler = () =>
						this.handleDatePickerClick('endDate');

					button2.addEventListener(
						'click',
						this.endDatePickerHandler,
						true
					);
				}
			}
		});
	},
}
</script>